<div class="he">
  <div>
    <a href="/merchant/transactions">
    <img class="w-20 ml-5" src="./assets/logo.svg" alt="">
    </a>
  </div>
 
  <!-- Button to toggle the modal -->
  <button 
    type="button"
    [attr.data-modal-target]="modalId"
    [attr.data-modal-toggle]="modalId"
    class="btn"
    (click)="openModal()">
    + Demande de compensation
  </button>
   
</div>
<!-- Use app-modal component, passing dynamic fields and form group -->
<!-- Flowbite Modal for new order -->
<div id="{{modalId}}" tabindex="-1" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
<div class="relative p-4 w-full max-w-md max-h-full">
  <!-- Modal content -->
  <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
    <!-- Modal header -->
    <div class="flex items-center justify-between p-4 md:p-5">
      <h3 class="text-xl font-semibold text-gray-900 dark:text-black">
        Faire ma demande
      </h3>
      <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" (click)="closeModal()">
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
    </div>
    <!-- Modal body -->
    <div class="p-4 md:p-5">
      <form [formGroup]="requestComensationForm" (ngSubmit)="onSubmit()">
        <!-- Titre B2B/B2C classique (optionnel) + son montant -->
        <div class="grid gap-4 mb-4 grid-cols-1">
          <div *ngFor="let field of newRequestCompensationFields">
            <label [for]="field.controlName" class="block mb-2 text-sm font-medium text-gray-900 dark:text-black">{{ field.label }}</label>

            <!-- Render select field -->
            <ng-container *ngIf="field.type === 'select'">
              <select 
                [id]="field.controlName"
                [formControlName]="field.controlName"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-black"
                [attr.required]="field.required ? true : null">
                <option [ngValue]="null" selected>{{ field.placeholder || 'Select an option' }}</option>
                <option *ngFor="let option of field.options" [value]="option.id">{{ option.label }}</option>
              </select>
            </ng-container>

            <!-- Render default input fields -->
            <ng-container *ngIf="field.type !== 'select'">
              <input 
                [type]="field.type"
                [id]="field.controlName"
                [formControlName]="field.controlName"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-black"
                [placeholder]="field.placeholder || ''"
                [attr.required]="field.required ? true : null">
            </ng-container>

            <!-- Validation error messages -->
            <div *ngIf="requestComensationForm.get(field.controlName)?.invalid && (requestComensationForm.get(field.controlName)?.dirty || requestComensationForm.get(field.controlName)?.touched)" class="text-red-600 text-xs mt-1">
              <div *ngIf="requestComensationForm.get(field.controlName)?.errors?.['min']">
                La valeur doit être supérieure ou égale à 0.
              </div>
              <div *ngIf="requestComensationForm.get(field.controlName)?.errors?.['maxBalance']">
                Vous ne pouvez demander plus que votre solde ({{ currentBalance | number:'1.0-0' }} XOF).
              </div>
            </div>
          </div>
        </div>

        <!-- Solde disponible pour le titre B2B sélectionné -->
        <div *ngIf="requestComensationForm.get('ticket')?.value && requestComensationForm.get('ticket')?.value !== BON_MARCHAND_OPTION" class="mb-4 text-sm font-medium text-gray-900 dark:text-black">
          Solde disponible : {{ currentBalance | number:'1.0-0' }} XOF
        </div>

        <!-- Bons cadeaux disponibles : révélées uniquement après avoir choisi "Bon marchand" ci-dessus -->
        <div class="mb-4" *ngIf="requestComensationForm.get('ticket')?.value === BON_MARCHAND_OPTION">
          <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-black">Bons cadeaux disponibles</label>
          <div class="flex flex-col gap-2">
            <label
              *ngFor="let voucher of merchantVouchers"
              class="flex items-center gap-2 text-sm text-gray-900 dark:text-black"
            >
              <input
                type="checkbox"
                [checked]="isVoucherSelected(voucher.tokenId)"
                (change)="toggleVoucher(voucher.tokenId, $any($event.target).checked)"
              />
              {{ voucher.balance | number:'1.0-0' }} XOF
            </label>
          </div>
        </div>

        <!-- Total demandé -->
        <div class="mb-4 text-sm font-semibold text-gray-900 dark:text-black">
          Total demandé : {{ totalDemande | number:'1.0-0' }} XOF
        </div>

        <!-- Submit button -->
        <div class="flex items-center justify-center space-x-4 mt-5">
          <button type="button" class="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center" (click)="closeModal()">Annuler</button>
          <button type="submit" class="text-white btn-modal focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center" [disabled]="requestComensationForm.invalid || totalDemande <= 0">Valider</button>
        </div>
      </form>
    </div>
  </div>
</div>
</div>

 <div class="card flex justify-content-center">
   <p-toast />
</div>